import React, { useState, useEffect } from "react";
import { ApiGet } from "../../../service/ApiService";
import { Form, Button, Alert, Row, Col } from "react-bootstrap";

const SmartBillForm = ({ formValues, handleInputChange, handleFileChange, handleFileUpload }) => {
    const [customers, setCustomers] = useState([]); // Initialize as an empty array
    const [warehouses, setWarehouses] = useState([]); // State for warehouses
    const [error, setError] = useState(null); // Initialize error state

    // Fetch customers on component load
    useEffect(() => {
        ApiGet(
            "/api/smartbill/customer/all",
            (response) => {
                setError(null);
                setCustomers(response || []); // Safely access response or set to an empty array
            },
            (error) => {
                setError(error.response?.data?.message || "A apărut o eroare.");
                setCustomers([]); // Clear the response data on error
            }
        );
    }, []);

    // Fetch warehouses on component load
    useEffect(() => {
        ApiGet(
            "/api/smartbill/warehouses",
            (response) => {
                // Asigură-te că response-ul conține o listă de depozite
                setWarehouses(response || []);
                if (response && response.length > 0) {
                    handleInputChange({ target: { name: "warehouse", value: response[0].warehouseName } });
                }
            },
            (error) => {
                console.error("Eroare la preluarea depozitelor.", error);
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Handle customer selection
    const handleCustomerSelect = (e) => {
        const clientId = e.target.value;
        const customer = customers.find((c) => parseInt(c.id) === parseInt(clientId));
        // Update the customerId in the formValues
        handleInputChange({ target: { name: "clientId", value: clientId } });

        console.log("Selected customer:", clientId, customer);
        // If a customer is selected, fill in the form values with the customer's data
        if (customer) {
            handleInputChange({ target: { name: "companyVatCode", value: customer.cif } });
            handleInputChange({ target: { name: "mentions", value: customer.mentions || "" } });
            handleInputChange({ target: { name: "observations", value: customer.observations || "" } });
        }
    };

    return (
        <Form onSubmit={handleFileUpload} className="mb-4">
            {/* Display Error Message */}
            {error && (
                <Alert variant="danger">
                    {error}
                </Alert>
            )}

            <Row>
                {/* Customer Dropdown */}
                <Col md={12}>
                    <Form.Group className="mb-3">
                        <Form.Label>Selectează Client</Form.Label>
                        <Form.Control
                            as="select"
                            name="clientId"
                            value={formValues.clientId || ""}
                            onChange={handleCustomerSelect}
                            style={{ fontSize: "1.2rem", padding: "0.75rem" }}
                        >
                            <option value="">-- Selectează un client --</option>
                            {customers.map((customer) => (
                                <option
                                    key={customer.id}
                                    value={customer.id}
                                    style={{ fontSize: "1.2rem" }}
                                >
                                    {customer.clientName} ({customer.cif})
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>Depozit</Form.Label>
                        <Form.Control
                            as="select"
                            name="warehouse"
                            value={formValues.warehouse || (warehouses.length > 0 ? warehouses[0].warehouseName : "")}
                            onChange={handleInputChange}
                        >
                            <option value="">-- Selectează un depozit --</option>
                            {warehouses.map((wh) => (
                                <option key={wh.id} value={wh.warehouseName}>
                                    {wh.warehouseName}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Col>

                <Col md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>Data emiterii</Form.Label>
                        <Form.Control
                            type="date"
                            name="issueDate"
                            value={formValues.issueDate}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                </Col>

                {/* Zile scadență */}
                <Col md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>Zile scadență</Form.Label>
                        <Form.Control
                            type="number"
                            name="dueDays"
                            value={formValues.dueDays || 14}
                            onChange={handleInputChange}
                            min="1"
                        />
                    </Form.Group>
                </Col>

                {/* Folosește stoc */}
                <Col md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>Descarcare gestiune</Form.Label>
                        <Form.Check
                            type="checkbox"
                            label="Scade produsele din stoc"
                            name="useStock"
                            checked={formValues.useStock}
                            onChange={(e) =>
                                handleInputChange({
                                    target: { name: e.target.name, value: e.target.checked },
                                })
                            }
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row>
                {/* Mențiuni */}
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Mențiuni</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="mentions"
                            value={formValues.mentions}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                </Col>

                {/* Observații */}
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Observații</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="observations"
                            value={formValues.observations}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                </Col>
            </Row>

            {/* Collapsed section for additional invoice values */}
            <Row>
                <Col md={4}>
                    <Form.Group controlId="formIsDraft">
                        <Form.Check
                            type="checkbox"
                            label="Ciorna"
                            name="isDraft"
                            checked={formValues.draft}
                            onChange={(e) =>
                                handleInputChange({
                                    target: { name: e.target.name, value: e.target.checked },
                                })
                            } />
                    </Form.Group>
                    <br />
                    <Form.Group controlId="formSaveToDb">
                        <Form.Check
                            type="checkbox"
                            label="Salvează în DB"
                            name="saveToDb"
                            checked={formValues.saveToDb}
                            onChange={(e) =>
                                handleInputChange({
                                    target: { name: e.target.name, value: e.target.checked },
                                })
                            } />
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Form.Group controlId="formSeriesName">
                        <Form.Label>Serie</Form.Label>
                        <Form.Control
                            type="text"
                            name="seriesName"
                            value={formValues.seriesName}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Form.Group controlId="formCurrency">
                        <Form.Label>Monedă</Form.Label>
                        <Form.Control
                            type="text"
                            name="currency"
                            value={formValues.currency}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Form.Group controlId="formLanguage">
                        <Form.Label>Limbă</Form.Label>
                        <Form.Control
                            type="text"
                            name="language"
                            value={formValues.language}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                </Col>
                <Col md={2}>
                    <Form.Group controlId="formPrecision">
                        <Form.Label>Precizie</Form.Label>
                        <Form.Control
                            type="number"
                            name="precision"
                            value={formValues.precision}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                </Col>

            </Row>

            {parseInt(formValues.id) === 0 && (
                <>
                    <Row>
                        {/* Upload File */}
                        <Col md={12}>
                            <Form.Group className="mb-3 mt-4">
                                <Form.Label>Încarcă fișier Excel</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept=".xlsx, .xls"
                                    onChange={handleFileChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Button variant="primary" type="submit">
                        Încarcă
                    </Button>
                </>
            )}
        </Form>
    );
};

export default SmartBillForm;